riot.tag2('raw-html', '', '', '', function(opts) {
  this.updateContent = () => {
    this.root.innerHTML = this.opts.content
  }

  this.on('update', () => {
    this.updateContent()
  })

  this.updateContent()
});



/** WEBPACK FOOTER **
 ** ./src/components/raw_html.tag
 **/